import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getContractListSummary() {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/contracts/contracts-summary/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },
  async getContractList(filters) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v2/contracts/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params: filters });
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },
};
